import React from 'react';
const Loader = () => {
    return (React.createElement("div", null, "Spinner Goes Here"));
};
export default Loader;
